import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import { Configuration } from 'msal/lib-commonjs/Configuration';
import { authorityUrl, authClientId, impersonationScope } from '../app/constants';


// Msal Configurations
export const config = (azurePolicy: string): Configuration => ({
    auth: {
        // authority: `https://ergotestinnovationaad.b2clogin.com/ergotestinnovationaad.onmicrosoft.com/${azurePolicy}`, // azurePolicy = Название политики, на которую нужно перенести пользователя (об этом дальше)
        authority: `${authorityUrl}${azurePolicy}`, // azurePolicy = Название политики, на которую нужно перенести пользователя (об этом дальше)
        validateAuthority: false,
        // clientId: 'ec1b2c8f-fb17-48db-a413-fc89da04fcd8', // ClientID вашего приложения Azure AD B2C
        clientId: `${authClientId}`, // ClientID вашего приложения Azure AD B2C
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false, // Лучше оставить false иначе кукисы имеют свойство накапливаться, что приводит к ошибке 431
    },
});

// Authentication Parameters
// Обязательно укажите полный путь, иначе не будет работать acquire silent token
// UPD!! если не срабатывает accquireTokenSilently - нужно заменить scopes на
// scopes: ['777aaa77a-7a77-7777-bb77-8888888aabc']'
const authenticationParameters = {
    scopes: [
      //  'https://ergotestinnovationaad.onmicrosoft.com/musclelab/user_impersonation',
      `${impersonationScope}`,
        'openid',
        'profile'
    ],
};

// Options
export const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: `${window.location.origin}/auth.html`,
};

export const authProvider = (customConfig: Configuration): MsalAuthProvider => new MsalAuthProvider(customConfig, authenticationParameters, options);
export const authProviderDefault = new MsalAuthProvider(config('b2c_1_susi'), authenticationParameters, options);
